"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import { AccountSessionMixins } from "@/service/account-session";
import { Debounce } from "vue-debounce-decorator";
let FileSaveConfig = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.noticeSwitch = false;
    this.noticeIconShow = false;
    this.noticeShow = "allow";
    this.noticeShowList = [
      {
        value: "allow",
        label: this.$t("notice-config.notice_config_open_allow")
      },
      {
        value: "ask",
        label: this.$t("notice-config.notice_config_open_ask")
      },
      {
        value: "disallow",
        label: this.$t("notice-config.notice_config_open_disallow")
      }
    ];
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.init_notice_switch();
      yield this.init_notice_icon_show();
      yield this.init_notice_show();
    });
  }
  // 消息通知的模式
  init_notice_show() {
    return __async(this, null, function* () {
      try {
        const noticeShow = yield API.get(`api://base.local/storages/preference/noticeShow`);
        this.noticeShow = noticeShow.data.value.show;
      } catch (error) {
        const _show = "allow";
        yield API.put(`api://base.local/storages/preference/noticeShow`, {
          show: _show
        });
        this.noticeShow = _show;
      }
    });
  }
  // 是否开启图标闪烁提醒
  init_notice_icon_show() {
    return __async(this, null, function* () {
      try {
        const noticeIconShow = yield API.get(`api://base.local/storages/preference/noticeIconShow`);
        this.noticeIconShow = noticeIconShow.data.value.flag;
      } catch (error) {
        const _flag = false;
        yield API.put(`api://base.local/storages/preference/noticeIconShow`, {
          flag: _flag
        });
        this.noticeIconShow = _flag;
      }
    });
  }
  // 是否开启浏览器消息提示音
  init_notice_switch() {
    return __async(this, null, function* () {
      try {
        const noticeSwitch = yield API.get(
          `api://base.local/storages/preference/noticeSwitch`
        );
        this.noticeSwitch = noticeSwitch.data.value.flag;
      } catch (error) {
        const _flag = false;
        yield API.put(`api://base.local/storages/preference/noticeSwitch`, {
          flag: _flag
        });
        this.noticeSwitch = _flag;
      }
    });
  }
  changeNotice(flag) {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.local/storages/preference/noticeSwitch`, {
          flag
        });
      } catch (error) {
        console.log(error);
      }
    });
  }
  changeNoticeShow(show) {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.local/storages/preference/noticeShow`, {
          show
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  changeNoticeIconShow(flag) {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.local/storages/preference/noticeIconShow`, {
          flag
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Debounce(600)
], FileSaveConfig.prototype, "changeNotice", 1);
__decorateClass([
  Debounce(400)
], FileSaveConfig.prototype, "changeNoticeShow", 1);
__decorateClass([
  Debounce(400)
], FileSaveConfig.prototype, "changeNoticeIconShow", 1);
FileSaveConfig = __decorateClass([
  Component
], FileSaveConfig);
export {
  FileSaveConfig as default
};
